import { Chat } from "./chat.types";
import { User } from "./user.types";

export enum FeedbackType {
  QUESTION = "question",
  COMPLAINT = "complaint",
}

export type Feedback = {
  id: string;
  sender: User;
  subject: string;
  body: string;
  type: FeedbackType;
  createdAt: string;
  chatId?: Chat["id"];
};
